import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import { withTranslation } from 'react-i18next';
import browserStorage from '../common/services/browserStorage';
import Dialog from '../common/components/Dialog';
import CollapsablePanel from '../common/components/CollapsablePanel';
import { Checkbox } from 'react-icheck';
import 'icheck/skins/minimal/minimal.css';
import cookieConsentService from '../common/services/cookieConsentService';
import { showCookiePreferencesModal, hideCookiePreferencesModal, logCookieConsent } from './actions';

class CookieConsent extends Component {
	constructor(props) {
		super(props);

		this.handleAcceptAll = this.handleAcceptAll.bind(this);
		this.handleRejectAll = this.handleRejectAll.bind(this);
		this.handleSavePreferences = this.handleSavePreferences.bind(this);
		this.handleCategoryChange = this.handleCategoryChange.bind(this);
		this.hideBanner = this.hideBanner.bind(this);
		this.handleCookiePolicyClick = this.handleCookiePolicyClick.bind(this);

		this.state = {
			showBanner: !browserStorage.getFromLocalStorage(props.franchisor, 'cookieConsent'),
			preferences: cookieConsentService.getCookiePreferences(props.franchisor),
		};
	}

	hideBanner() {
		this.setState({ showBanner: false });
	}

	savePreferences(prefs) {
		this.setState({ preferences: prefs });

		cookieConsentService.saveCookiePreferences(this.props.franchisor, prefs);
		// sent the updated consent to the server
		this.props.logCookieConsent(cookieConsentService.getCookieConsent(this.props.franchisor));

		this.hideBanner();
		this.props.hideCookiePreferencesModal();
	}

	handleAcceptAll() {
		const cookieCategories = cookieConsentService.getCookieCategories(this.props.franchisor);
		const allAccepted = Object.keys(cookieCategories).reduce((acc, key) => {
			acc[key] = true;
			return acc;
		}, {});
		this.savePreferences(allAccepted);
	}

	handleRejectAll() {
		const cookieCategories = cookieConsentService.getCookieCategories(this.props.franchisor);
		const allRejected = Object.entries(cookieCategories).reduce((acc, [key, category]) => {
			acc[key] = category.required ? true : false;
			return acc;
		}, {});
		this.savePreferences(allRejected);
	}

	handleSavePreferences() {
		this.savePreferences(this.state.preferences);
	}

	handleCategoryChange(cat) {
		const cookieCategories = cookieConsentService.getCookieCategories(this.props.franchisor);
		if (cookieCategories[cat].required) return;
		this.setState({ preferences: { ...this.state.preferences, [cat]: !this.state.preferences[cat] } });
	}

	handleCookiePolicyClick() {
		this.props.hideCookiePreferencesModal();
		this.props.history.push('/public/cookie-policy');
	};

	renderPreferencesDialog() {
		const { preferences } = this.state;
		const { hideCookiePreferencesModal, showModal, t } = this.props;
		const cookieCategories = cookieConsentService.getCookieCategories(this.props.franchisor);

		const header = t('FO_CookieDialog_Heading');
		const body = <div>
			<div dangerouslySetInnerHTML={{ __html: t('FO_CookieDialog_Description') }} />
			{Object.entries(cookieCategories).map(([key, category]) => {
				return category.cookies.length > 0 &&
					<CollapsablePanel key={key} collapsed title={<label>
						<Checkbox
							label={category.label}
							checked={preferences[key]}
							disabled={category.required}
							onChange={() => this.handleCategoryChange(key)}
							checkboxClass='icheckbox_minimal' increaseArea='20%'
						/>
					</label>} style={{ marginBottom: 15 }}>
						<div style={{ fontSize: 12 }}>{category.description}</div>
					</CollapsablePanel>;
			})}
			<div><span>{t('FO_CookieDialog_MoreInfo')}</span> <Link onClick={this.handleCookiePolicyClick}>{t('FO_CookieBanner_CookiePolicy')}</Link></div>
		</div>;
		const footer = <div>
			<Button className='btn-xss btn-block-xxs btn-primary' style={{ marginRight: 10 }} onClick={this.handleRejectAll}>{t('FO_CookieDialog_Reject')}</Button>
			<Button className='btn-xss btn-block-xxs btn-primary' style={{ marginRight: 10 }} onClick={this.handleSavePreferences}>{t('FO_CookieDialog_Save')}</Button>
			<Button className='btn-xss btn-block-xxs btn-primary' onClick={this.handleAcceptAll}>{t('FO_CookieDialog_Accept')}</Button>
		</div>
		return <Dialog show={showModal} onHide={hideCookiePreferencesModal} header={header} body={body} footer={footer} />
	}

	render() {
		const { showBanner } = this.state;
		const { showModal, showCookiePreferencesModal, t } = this.props;
		if (!showBanner && !showModal) return null;
		return <div>
			{showBanner && !showModal &&
				<div className='cookie-consent-container'>
					<div className='cookie-consent-bar'>
						<h4>
							{t('FO_CookieBanner_Heading')}
						</h4>
						<div className='cookie-consent-content'>
							<div className='cookie-consent-text'>
								{t('FO_CookieBanner_Description')} <Link to='/public/cookie-policy'>{t('FO_CookieBanner_CookiePolicy')}</Link>
							</div>
							<div>
								<Button className='btn-xss btn-block-xxs' style={{ marginRight: 10 }} onClick={showCookiePreferencesModal}>{t('FO_CookieBanner_Customise')}</Button>
								<Button className='btn-xss btn-block-xxs btn-primary' style={{ marginRight: 10 }} onClick={this.handleRejectAll}>{t('FO_CookieBanner_RejectAll')}</Button>
								<Button className='btn-xss btn-block-xxs btn-primary' onClick={this.handleAcceptAll}>{t('FO_CookieBanner_AcceptAll')}</Button>
							</div>
						</div>
					</div>
				</div>
			}
			{this.renderPreferencesDialog()}
		</div>;
	}
};

const mapStateToProps = state => ({
	franchisor: state.configuration.franchisor,
	showModal: state.configuration.cookieConsent.showModal
});

const mapDispatchToProps = {
	showCookiePreferencesModal,
	hideCookiePreferencesModal,
	logCookieConsent
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(CookieConsent));